import { get } from 'lodash';
import { POST_FORM_NAME } from '../services/post-form-settings';

export const getForms = state => state.form;
export const getPostForm = state => get(getForms(state), POST_FORM_NAME, {});
